/**
 * Shared numeric thresholds so portal + (eventually) mobile agree.
 *
 * BUG_LIST #125: "Best Fits" was computed as >=75 on the portal
 * (CollegeLists) but >=80 on mobile, so the same athlete saw different
 * counts. The portal value (75) is canonical here — mobile should adopt the
 * same constant. Do NOT inline the literal; import this.
 */
export const BEST_FITS_MATCH_SCORE_THRESHOLD = 75;

/**
 * A school counts as a "best fit" when its normalized match score clears the
 * shared threshold. Null/undefined scores never qualify.
 */
export const isBestFit = (matchScoreNorm: number | null | undefined): boolean =>
  typeof matchScoreNorm === 'number' && matchScoreNorm >= BEST_FITS_MATCH_SCORE_THRESHOLD;
